import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import RouteLoading from "../components/Loaders/RouteLoading";
import useLoggedIn from "../hooks/useLoggedIn";

const GuestProtectedRoutes = () => {
  const { isLoggedIn, isLoading } = useLoggedIn();
 
  const location = window.location.pathname;
  const isAuthPage = location.includes("/sign-in") || location.includes("/login") || location.includes("/sign-up") || location.includes("/forgot-password") || location.includes("/reset-password");

  // If loading but we are already on an auth page, don't show the global loader
  // to prevent unmounting the component (which would clear its internal/Redux state on remount)
  if (isLoading && !isAuthPage) return <RouteLoading />;
 
  // const navigatePath = isEmailVerified ? "/scheme" : "/verify-email";
 
  const navigatePath = isLoggedIn ? "mytask" : "sign-in";
 
  const renderLayout = isLoggedIn ? (
    <Navigate to={`/${navigatePath}`} replace />
  ) : (
    <Outlet />
  );
 
  return renderLayout;
};

export default GuestProtectedRoutes;
